import { HierarchyMenuItem } from '@siza-staff-care/shared/app-state';
import { securityMappings } from './security-mappings';

// Hierarchical structure of the menu items.
export const menuStructure = (
	allocationManagementScreenName: string,
	allocationName: string,
	sexAsGender: boolean | undefined,
): HierarchyMenuItem[] => [
	{
		name: 'Rotas',
		key: 'rotas-menu',
		route: '',
		children: [
			{ name: 'Planned rota', key: securityMappings.Schedules, route: 'planned-rota' },
			{ name: 'Current rota', key: securityMappings.ShiftControl, route: 'current-rota' },
			{ name: 'Rota correction', key: securityMappings.ShiftCorrection, route: 'rota-correction' },
			{
				name: 'Rota builder',
				key: 'rotas-rota-builder-menu',
				route: '',
				children: [
					{ name: 'Rota configuration', key: securityMappings.UnitMaintenance, route: 'rota-configuration' },
					{ name: 'Rules', key: securityMappings.Rules, route: 'rota-rules' },
					{ name: 'Rota initial setup', key: securityMappings.UnitsAdmin, route: 'rota-initial-setup' },
					{ name: 'Save levels', key: securityMappings.SaveLevelsAdmin, route: 'save-levels' },
					{ name: 'Shift colours', key: securityMappings.ShiftColoursAdmin, route: 'shift-colours' },
					{ name: 'Closure levels', key: securityMappings.ShiftControlLevelsAdmin, route: 'closure-levels' },
					{ name: 'Team colours', key: securityMappings.TeamColoursAdmin, route: 'team-colours' },
				],
			},
		],
	},
	{
		name: 'Staff',
		key: 'staff-menu',
		route: '',
		children: [
			{
				name: 'Management',
				key: 'staff-management-menu',
				route: '',
				children: [
					{ name: 'Staff records', key: securityMappings.StaffMaintenance, route: 'staff-records' },
					{ name: 'Leave requests', key: securityMappings.StaffRequests, route: 'leave-requests' },
					{ name: 'Shift requests', key: securityMappings.ShiftRequests, route: 'shift-requests' },
					{ name: 'Expenses query', key: securityMappings.ExpensesQuery, route: 'expenses-query' },
					{ name: 'Items matrix', key: securityMappings.ItemsMatrix, route: 'items-matrix' },
					{ name: 'Job adverts query', key: securityMappings.JobAdvertsQuery, route: 'job-adverts-query' },
					{ name: 'Requests query', key: securityMappings.RequestsQuery, route: 'requests-query' },
					{ name: 'View requests', key: securityMappings.ViewRequests, route: 'view-requests' },
					{ name: 'Availability', key: securityMappings.Availability, route: 'availability' },
					{ name: 'Unavailability', key: securityMappings.Unavailability, route: 'unavailability' },
					{ name: 'Time off pattern', key: securityMappings.TimeOffPattern, route: 'time-off-pattern' },
					{ name: 'T&A adjustments', key: securityMappings.TAAdjustments, route: 'ta-adjustments' },
					{ name: 'Work patterns', key: securityMappings.WorkPatterns, route: 'work-patterns' },
					{
						name: 'Authenticator devices',
						key: securityMappings.AuthenticatorDevices,
						route: 'authenticator-devices',
					},
				],
			},
			{
				name: 'End user',
				key: 'staff-end-user-menu',
				route: '',
				children: [
					{
						name: 'My record',
						key: securityMappings.StaffMaintenanceEndUser,
						controlsKey: securityMappings.StaffMaintenance,
						route: 'my-record',
					},
					{ name: 'My Staff.Care', key: securityMappings.MyStaffCare, route: 'my-staff-care' },
					{
						name: 'View requests',
						key: securityMappings.ViewRequestsEndUser,
						controlsKey: securityMappings.ViewRequests,
						route: 'my-view-requests',
					},
					{ name: 'Alerts', key: securityMappings.Alerts, route: 'alerts' },
					{ name: 'Messages', key: securityMappings.Messages, route: 'messages' },
					{ name: 'Favourites', key: securityMappings.Favourites, route: 'favourites' },
					{ name: 'Event viewer', key: securityMappings.EventViewer, route: 'event-viewer' },
					{ name: 'Skill viewer', key: securityMappings.SkillViewer, route: 'skill-viewer' },
				],
			},
		],
	},
	{
		name: 'Resource bookings',
		key: securityMappings.ResourceBookings, // Originally Room bookings - but name will be replaced with a system setting.
		route: 'resource-bookings',
	},
	{
		name: 'Bank',
		key: 'bank-menu',
		route: '',
		children: [
			{ name: 'Bank authorise', key: securityMappings.BankAuthorise, route: 'bank-authorise' },
			{ name: 'Bank query', key: securityMappings.BankQuery, route: 'bank-query' },
			{ name: 'Bank paid', key: securityMappings.BankPaid, route: 'bank-paid' },
			{ name: 'Bank staff', key: securityMappings.BankStaff, route: 'bank-staff' },
			{ name: 'Bank maintenance', key: securityMappings.BankMaintenance, route: 'bank-maintenance' },
			{
				name: 'Reports',
				key: 'bank-reports-menu',
				route: '',
				children: [
					{ name: 'Bank report', key: securityMappings.BankReport, route: 'bank-report' },
					{ name: 'Bank paid report', key: securityMappings.BankPaidReport, route: 'bank-paid-report' },
					{
						name: 'Bank statistics',
						key: securityMappings.BankStatisticsReport,
						route: 'bank-statistics-report',
					},
				],
			},
		],
	},
	{
		name: 'Reporting',
		key: 'reporting-menu',
		route: '',
		children: [
			{ name: 'Auto-runs', key: securityMappings.ReportAutoRuns, route: 'report-auto-runs' },
			{ name: 'Data lists', key: securityMappings.LookupsReport, route: 'data-lists' },
			{
				name: 'Items',
				key: 'reporting-items-menu',
				route: '',
				children: [
					{ name: 'Events', key: securityMappings.EventsReport, route: 'events-report' },
					{
						name: 'Skills/competencies',
						key: securityMappings.SkillsCompetenciesReport,
						route: 'skills-competencies-report',
					},
					{ name: 'Staff extras', key: securityMappings.StaffExtrasReport, route: 'staff-extras-report' },
					{ name: 'Training', key: securityMappings.TrainingsReport, route: 'training-report' },
					{
						name: 'Soft form extract',
						key: securityMappings.SoftFormExtractReport,
						route: 'soft-forms-extract-report',
					},
					{ name: 'Soft forms', key: securityMappings.SoftFormsReport, route: 'soft-forms-report' },
				],
			},
			{
				name: 'Leaves/shifts',
				key: 'reporting-leave-shifts-menu',
				route: '',
				children: [
					{
						name: 'Absenteeism rates',
						key: securityMappings.AbsenteeismRatesReport,
						route: 'absenteeism-rates-report',
					},
					{ name: 'Bradford', key: securityMappings.LeaveBradfordReport, route: 'leave-bradford-report' },
					{
						name: 'Leave detailed',
						key: securityMappings.LeaveReport,
						route: 'leave-detailed-report',
					},
					{ name: 'Leave summary', key: securityMappings.StaffLeavesReport, route: 'leave-summary-report' },
					{ name: 'Limits', key: securityMappings.LeaveLimitsReport, route: 'leave-limits-report' },
					{ name: 'Requests', key: securityMappings.RequestsReport, route: 'leave-requests-report' },
					{
						name: 'Transaction extract',
						key: securityMappings.TransactionExtractReport,
						route: 'transaction-extract-report',
					},
					{ name: 'WTD report', key: securityMappings.WorkedHoursReport, route: 'wtd-report' },
				],
			},
			{
				name: 'Management',
				key: 'reporting-management-menu',
				route: '',
				children: [
					{ name: 'Budget', key: securityMappings.BudgetReport, route: 'budget-report' },
					{
						name: 'Lost hours',
						key: securityMappings.LostHoursDashboard,
						route: 'lost-hours-dashboard-report',
					},
					{ name: 'Patient hours', key: securityMappings.PatientHoursReport, route: 'patient-hours-report' },
					{ name: 'Rota analysis', key: securityMappings.RotaAnalysisReport, route: 'rota-analysis-report' },
					{
						name: 'Skill mix needs',
						key: securityMappings.SkillMixNeedsReport,
						route: 'skill-mix-needs-report',
					},
					{ name: 'Establishment', key: securityMappings.EstablishmentReport, route: 'establishment-report' },
					{
						name: 'Absence monitoring',
						key: securityMappings.AbsenceMonitoringReport,
						route: 'absence-monitoring-report',
					},
				],
			},
			{
				name: 'Payroll',
				key: securityMappings.Payroll,
				route: 'payroll-report',
			},
			{
				name: allocationManagementScreenName,
				key: securityMappings.RoomOccupancy,
				route: 'resource-bookings-report',
			},
			{
				name: 'Rotas',
				key: 'reporting-rotas-menu',
				route: '',
				children: [
					{
						name: 'Calendar month',
						key: securityMappings.MonthlySchedulesReport,
						route: 'calendar-month-report',
					},
					{
						name: 'Closure level report',
						key: securityMappings.ShiftControlLevelsReport,
						route: 'closure-level-report',
					},
					{ name: 'Closure report', key: securityMappings.UnitClosureReport, route: 'closure-report' },
					{ name: 'Date range', key: securityMappings.DateSchedulesReport, route: 'date-range-report' },
					{
						name: 'Rank attendance',
						key: securityMappings.RankAttendanceReport,
						route: 'rank-attendance-report',
					},
					{ name: 'Rota', key: securityMappings.UnitSchedulesReport, route: 'rota-report' },
					{ name: 'Save levels', key: securityMappings.SaveLevelsReport, route: 'save-levels-report' },
					{
						name: 'Shift attendance',
						key: securityMappings.ShiftAttendanceReport,
						route: 'shift-attendance-report',
					},
				],
			},
			{
				name: 'Staff',
				key: 'report-staff-menu',
				route: '',
				children: [
					{ name: 'Census', key: securityMappings.CensusReport, route: 'census-report' },
					{ name: 'Contracts', key: securityMappings.StaffContractsReport, route: 'contracts-report' },
					{ name: 'Expenses', key: securityMappings.ExpensesReport, route: 'expenses-report' },
					{
						name: 'Individual service',
						key: securityMappings.IndividualServiceReport,
						route: 'individual-service-report',
					},
					{ name: 'Job adverts', key: securityMappings.JobAdvertsReport, route: 'job-adverts-report' },
					{ name: 'Lost hours', key: securityMappings.LostHoursReport, route: 'lost-hours-report' },
					{ name: 'Register', key: securityMappings.StaffRegisterReport, route: 'register-report' },
					{ name: 'Roll call', key: securityMappings.RollCallReport, route: 'roll-call-report' },
					{ name: 'Signoffs', key: securityMappings.SignoffsReport, route: 'signoffs-report' },
					{ name: 'Staff levels', key: securityMappings.StaffLevelsReport, route: 'staff-levels-report' },
					{
						name: 'Starters & leavers',
						key: securityMappings.StartersLeaversReport,
						route: 'starters-leavers-report',
					},
					{
						name: 'T&A exceptions',
						key: securityMappings.TAExceptionsReport,
						route: 't-and-a-exceptions-report',
					},
					{
						name: 'T&A individual',
						key: securityMappings.TAIndividualReport,
						route: 't-and-a-individual-report',
					},
					{ name: 'Timesheets', key: securityMappings.TimesheetsReport, route: 'timesheets-report' },
					{ name: 'Turnover', key: securityMappings.StaffTurnoverReport, route: 'turnover-report' },
				],
			},
		],
	},
	{
		name: 'Admin',
		key: 'admin-menu',
		route: '',
		children: [
			{ name: 'Alert groups', key: securityMappings.AlertGroupsAdmin, route: 'alert-groups' },
			{
				name: 'Items',
				key: 'admin-items-menu',
				route: '',
				children: [
					{ name: 'Documents', key: securityMappings.DocumentsAdmin, route: 'documents' },
					{ name: 'Folders', key: securityMappings.FoldersAdmin, route: 'folders' },
					{ name: 'Events', key: securityMappings.EventsAdmin, route: 'events' },
					{
						name: 'Skills/competencies',
						key: securityMappings.SkillsCompetenciesAdmin,
						route: 'skills-competencies',
					},
					{ name: 'Staff extras', key: securityMappings.StaffExtrasAdmin, route: 'staff-extras' },
					{ name: 'Training', key: securityMappings.TrainingAdmin, route: 'trainings' },
					{ name: 'Soft forms', key: securityMappings.SoftFormsMaintenance, route: 'soft-forms' },
					{
						name: 'Mail merge templates',
						key: securityMappings.TemplatesAdmin,
						route: 'mail-merge-templates',
					},
				],
			},
			{
				name: 'Leave',
				key: 'admin-leave-menu',
				route: '',
				children: [
					{ name: 'Holiday dates', key: securityMappings.HolidayDatesAdmin, route: 'holiday-dates' },
					{ name: 'Job title (leave)', key: securityMappings.JobTitleLeaveAdmin, route: 'job-title-leave' },
					{ name: 'Leave accruals', key: securityMappings.LeaveAccrualsAdmin, route: 'leave-accruals' },
					{ name: 'Leave codes', key: securityMappings.LeaveCodesAdmin, route: 'leave-codes' },
					{ name: 'Leave limits', key: securityMappings.LeaveLimitsAdmin, route: 'leave-limits' },
					{ name: 'Leave audit', key: securityMappings.LeaveAudits, route: 'leave-audit' },
					{
						name: 'Third party reasons',
						key: securityMappings.ThirdPartyReasonsAdmin,
						route: 'third-party-reasons',
					},
				],
			},
			{ name: 'Leave rollover', key: securityMappings.RolloverLeaveDates, route: 'leave-rollover' },
			{ name: `${allocationName}`, key: securityMappings.ResourceAdmin, route: 'resources' },
			{
				name: 'Staff',
				key: 'admin-staff-menu',
				route: '',
				children: [
					{ name: 'Agencies', key: securityMappings.AgenciesAdmin, route: 'agencies' },
					{ name: 'Bank priorities', key: securityMappings.BankPrioritiesAdmin, route: 'bank-priorities' },
					{ name: 'Ethnicities', key: securityMappings.EthnicitiesAdmin, route: 'ethnicities' },
					{ name: 'Expense forms', key: securityMappings.ExpenseForms, route: 'expense-forms' },
					{ name: 'Favourites', key: securityMappings.FavouritesAdmin, route: 'favourites-builder' },
					{
						name: sexAsGender ? 'Genders' : 'Sexes',
						key: securityMappings.SexesAdmin,
						route: sexAsGender ? 'genders' : 'sexes',
					},
					{ name: 'Grades', key: securityMappings.GradesAdmin, route: 'grades' },
					{
						name: 'Job advertisements',
						key: securityMappings.JobAdvertisementsAdmin,
						route: 'job-advertisements',
					},
					{ name: 'Job descriptions', key: securityMappings.JobDescriptionsAdmin, route: 'job-descriptions' },
					{ name: 'Marital status', key: securityMappings.MaritalsAdmin, route: 'marital-status' },
					{ name: 'Messaging', key: securityMappings.MessagingAdmin, route: 'messaging-configuration' },
					{ name: 'Nationalities', key: securityMappings.NationalitiesAdmin, route: 'nationalities' },
					{ name: 'Pay codes', key: securityMappings.PayCodesAdmin, route: 'pay-codes' },
					{ name: 'Payroll numbers', key: securityMappings.PayrollNumbersAdmin, route: 'payroll-numbers' },
					{ name: 'Ranks', key: securityMappings.RanksAdmin, route: 'ranks' },
					{ name: 'Staff types', key: securityMappings.StaffTypesAdmin, route: 'staff-types' },
					{
						name: 'Starter/leaver reasons',
						key: securityMappings.StarterLeaverReasonsAdmin,
						route: 'starter-leaver-reasons',
					},
					{ name: 'Titles', key: securityMappings.TitlesAdmin, route: 'titles' },
					{ name: 'Usernames', key: securityMappings.AccessCodesAdmin, route: 'usernames' },
					{ name: 'Workflows', key: securityMappings.WorkflowAdmin, route: 'workflows' },
				],
			},
			{
				name: 'Security',
				key: 'admin-security-menu',
				route: '',
				children: [
					{
						name: 'Security configuration',
						key: securityMappings.StaffSecurityAdmin,
						route: 'security-config',
					},
					{ name: 'Security groups', key: securityMappings.StaffSecurityGroup, route: 'security-groups' },
				],
			},
			{
				name: 'System',
				key: 'admin-system-menu',
				route: '',
				children: [
					{ name: 'Contract dates', key: securityMappings.ContractDates, route: 'contract-dates' },
					{ name: 'Current logins', key: securityMappings.CurrentLogins, route: 'current-logins' },
					{ name: 'Date extensions', key: securityMappings.DateExtensions, route: 'date-extensions' },
					{ name: 'Data loader', key: securityMappings.GenericDataLoad, route: 'data-loader' },
					{ name: 'External T&A', key: securityMappings.ExternalTA, route: 'external-ta' },
					{
						name: 'Leave balance extract',
						key: securityMappings.LeaveBalanceExtractReport,
						route: 'leave-balance-extract',
					},
					{ name: 'Public API keys', key: securityMappings.PublicApiKeysAdmin, route: 'public-api-keys' },
					{ name: 'System colours', key: securityMappings.SystemColoursAdmin, route: 'system-colours' },
					{ name: 'System info', key: securityMappings.SystemInfo, route: 'system-info' },
					{ name: 'System settings', key: securityMappings.SystemSettings, route: 'system-settings' },
					{
						name: 'Transaction audits',
						key: securityMappings.TransactionAudits,
						route: 'transaction-audits',
					},
					{ name: 'View audit', key: securityMappings.ViewAudit, route: 'view-audit' },
				],
			},
		],
	},
	{
		name: 'Dashboards',
		key: securityMappings.Dashboards,
		route: 'dashboards',
	},
];
